(() => {
  'use strict';

  if (document.documentElement.dataset.senixKitCartInitialized === 'true') return;
  document.documentElement.dataset.senixKitCartInitialized = 'true';

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-senix-remove-kit]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    const instance = button.dataset.senixRemoveKit;
    const lines = [...document.querySelectorAll('[data-senix-kit-instance]')]
      .filter((node) => node.dataset.senixKitInstance === instance && node.dataset.line);
    if (!lines.length) return;

    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Removing…';
    const updates = Object.fromEntries(lines.map((line) => [line.dataset.line, 0]));

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!response.ok) throw new Error('Kit could not be removed.');
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
      await refreshCartSurfaces(cart);
    } catch (_error) {
      button.removeAttribute('aria-busy');
      button.textContent = 'Try Again';
    }
  });

  async function refreshCartSurfaces(cart) {
    if (document.getElementById('main-cart-items')) {
      const response = await fetch(window.location.href, { headers: { Accept: 'text/html' } });
      const documentCopy = new DOMParser().parseFromString(await response.text(), 'text/html');
      const current = document.getElementById('main-cart-items');
      const replacement = documentCopy.getElementById('main-cart-items');
      if (current && replacement) current.replaceWith(replacement);
    }
    if (window.halo && typeof window.halo.updateSidebarCart === 'function') window.halo.updateSidebarCart(cart);
  }
})();
